import { useEffect } from 'react'
import { loadMetaPixel } from '../utils/metaPixel'

/**
 * Loads the Meta Pixel AFTER the page is interactive — on the first user
 * interaction, or when the browser goes idle — so the third-party script never
 * competes with the hero image or delays first paint.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    let hasLoaded = false
    const events: Array<keyof WindowEventMap> = [
      'pointerdown',
      'keydown',
      'scroll',
      'touchstart',
    ]

    const start = () => {
      if (hasLoaded) return
      hasLoaded = true
      cleanup()
      loadMetaPixel()
    }

    const cleanup = () => {
      events.forEach((event) => window.removeEventListener(event, start))
    }

    events.forEach((event) =>
      window.addEventListener(event, start, { once: true, passive: true }),
    )

    const idle = window.requestIdleCallback
      ? window.requestIdleCallback(start, { timeout: 4000 })
      : window.setTimeout(start, 3000)

    return () => {
      cleanup()
      if (window.cancelIdleCallback && typeof idle === 'number') {
        window.cancelIdleCallback(idle)
      } else {
        window.clearTimeout(idle as number)
      }
    }
  }, [])
}
